import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../../pages/Navbar";
import Footer from "../../pages/Footer";
import ConstructionBanner from "./ConstructionBanner";

const Layout = ({ children }) => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const pageTitles = {
      "/": t("title.home"),
      "/home": t("title.home"),
      "/become-partner": t("title.becomePartner"),
      "/welcome": t("title.welcome"),
      "/cart": t("title.cart"),
      "/login": t("title.login"),
      "/about": t("title.about"),
      "/contact": t("title.contact"),
      "/partners": t("title.partners"),
      "/checkout": t("title.checkout"),
      "/terms-and-conditions": t("title.terms"),
      "/create-event": t("title.createEvent"),
      "/admin-dashboard": t("title.adminDashboard"),
      "/success": t("title.success"),
      "/my-orders": t("title.myOrders"),
      "/manage-company": t("title.manageCompany"),
      "/admin-orders-validation": t("title.adminOrdersValidation"),
      "/provider-dashboard": t("title.providerDashboard"),
      "/provider-dashboard-product-list": t("title.providerProductList"),
      "/provider-dashboard-subscriptions": t("title.providerSubscriptions"),
      "/provider-dashboard-edit": t("title.providerEdit"),
      "/provider-dashboard-service-list": t("title.providerServiceList"),
      "/become-provider": t("title.becomeProvider"),
      "/provider/profile": t("title.providerProfile"),
      "/providers-requests": t("title.providersRequests"),
      "/providers-list": t("title.providersList"),
      "/unauthorized": t("title.unauthorized"),
    };

    document.title = pageTitles[location.pathname] || t("title.default");
  }, [location, t, i18n.language]);

  return (
    <div className="flex flex-col min-h-screen">
      <ConstructionBanner></ConstructionBanner>
      <Navbar />
      <main className="flex-grow mt-[56px]">
        {children ? children : <Outlet />}
      </main>
      <Footer></Footer>
    </div>
  );
};

export default Layout;
